<template>
<div id ="tag-create">
  <tag-form></tag-form>
</div>
</template>

<script>
import TagForm from '@/components/TagForm'

export default {
  components: {
    'tag-form': TagForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TagCreate.vue